(() => {
  const normalize = (text) => text.replace(/\s+/g, ' ').trim();
  const styleHeadings = () => {
    document.querySelectorAll('#MainContent .product__description.rte p').forEach((paragraph) => {
      const meaningful = [...paragraph.childNodes].filter((node) => normalize(node.textContent || '') || node.nodeName === 'BR');
      const first = meaningful[0];
      if (!first || first.nodeType !== 1 || !first.matches('strong, b')) return;
      const text = normalize(paragraph.textContent || '');
      const boldText = normalize([...paragraph.querySelectorAll('strong, b')].map((node) => node.textContent).join(' '));
      if (text && text.length <= 100 && text === boldText && !paragraph.querySelector('br')) {
        paragraph.classList.add('ppb-description-heading');
      } else if (meaningful[1]?.nodeName === 'BR' && normalize(first.textContent || '').length <= 100) {
        first.classList.add('ppb-description-heading-inline');
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', styleHeadings, { once: true });
  else styleHeadings();
  document.addEventListener('shopify:section:load', styleHeadings);
})();
